<!--
 * @Author: Vben
 * @Description: logo component
-->
<template>
  <div class="anticon" :class="getAppLogoClass" @click="goHome">
    <SvgIcon :name="getName" :size="props.size" />
    <!-- <div class="ml-2 truncate md:opacity-100" :class="getTitleClass" v-show="showTitle">
      {{ title }}
    </div> -->
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useGo } from '/@/hooks/web/usePage';
  import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { PageEnum } from '/@/enums/pageEnum';
  import { useUserStore } from '/@/store/modules/user';
  import { SvgIcon } from '/@/components/Icon';
  import { useAppStore } from '/@/store/modules/app';

  const props = defineProps({
    /**
     * The theme of the current parent component
     */
    theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
    /**
     * Whether to show title
     */
    showTitle: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
    /**
     * The size of the icon
     */
    size: { type: Number, default: 90 },

    /**
     * 简单模式
     */
    simple: { type: Boolean, default: false },
  });

  const { prefixCls } = useDesign('app-logo');
  const { getCollapsedShowTitle } = useMenuSetting();

  const userStore = useUserStore();
  const go = useGo();
  const appStore = useAppStore();
  const getAppLogoClass = computed(() => [
    prefixCls,
    { 'collapsed-show-title': unref(getCollapsedShowTitle) },
  ]);

  const getName = computed(() => {
    const theme = appStore.getDarkMode;
    let name = 'icon';
    if (props.simple) {
      name = `${name}-simple`;
    }
    if (theme === 'light') {
      return name;
    }
    return `${name}-dark`;
  });

  function goHome() {
    go(userStore.getUserInfo.homePath || PageEnum.HOME);
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    padding-left: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      line-height: normal;
    }
  }
</style>
